module.exports = __webpack_public_path__ + "media/images/icons/outlined/pull-request-fc1e5941f221b1ec7b0ec83770c74186.svg";